var map = {
	"./amex.png": "7145",
	"./aura.png": "2bd8",
	"./diners.png": "ec80",
	"./discover.png": "697a",
	"./elo.png": "4aad",
	"./hiper.png": "4d7b",
	"./hipercard.png": "4bc7",
	"./jcb.png": "1949",
	"./master.png": "c6a1",
	"./placeholder.png": "c9af",
	"./visa.png": "15b2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "61f4";